import { Link } from '@material-ui/core';

import { useTLang } from 'intl/intl';
import makeClasses from './ContactInfo.style';

import type { UserInOrderDetail } from 'shared/domain';

export function ContactInfo(props: Props) {
  const { showPhone, showAddress, user } = props;

  const locLat = user.address.location.coordinates.lat;
  const locLng = user.address.location.coordinates.lng;
  // const linkToViewMap = `https://www.google.com/maps?q=${locLat},${locLng}`
  const linkToViewMap = `https://www.google.com/maps/search/?api=1&query=${locLat},${locLng}`;
  const showLinkToViewMap = showAddress && !isNaN(locLat) && !isNaN(locLng);

  const lang = {
    phone: useTLang({ id: 'order.detail.clientModule.contact.phone' }),
    zipCode: useTLang({ id: 'order.detail.clientModule.contact.zipCode' }),
    neighborhood: useTLang({
      id: 'order.detail.clientModule.contact.neighborhood',
    }),
    mapLink: useTLang({
      id: 'order.detail.clientModule.contact.mapLink',
    }),
  };

  const _classes = makeClasses();

  return (
    <section aria-label='contact-info' className={_classes.info}>
      <p aria-label='phone-number' hidden={!showPhone}>
        <span>{lang.phone}</span>
        {user.phone.number}
      </p>

      {showAddress && (
        <>
          <div className={_classes.streetContainer}>
            <p aria-label='street'>{user.address.street}</p>
            {showLinkToViewMap && (
              <Link
                rel='external'
                target='_blank'
                aria-label='view-map'
                href={linkToViewMap}
                className={_classes.viewMap}
              >
                {lang.mapLink}
              </Link>
            )}
          </div>

          <p aria-label='description'>{user.address.description}</p>

          <p aria-label='zip-code' hidden={!user.address.location.zipCode}>
            <span>{lang.zipCode}</span>
            {user.address.location.zipCode}
          </p>

          <p
            aria-label='neighborhood'
            hidden={!user.address.location.neighborhood}
          >
            <span>{lang.neighborhood}</span>
            {user.address.location.neighborhood}
          </p>
        </>
      )}
    </section>
  );
}

interface Props {
  showPhone: boolean;
  showAddress: boolean;
  user: UserInOrderDetail;
}
